var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasPropertisData(_vm.parsedData, _vm.deviceBreakdownProps))?_c('GroupMetrics',{attrs:{"properties":_vm.deviceBreakdownProps,"parsed-data":_vm.parsedData,"map-icons":_vm.mapIcons,"reverse":true},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Device Breakdown")]},proxy:true}],null,false,1081442120)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }